@if (notfound()) {
  @if (errorStatus() === 503) {
    <gea-shop-server-error></gea-shop-server-error>
  } @else {
    <gea-shop-not-found></gea-shop-not-found>
  }
} @else {
  @let ppc = productPageContent();
  @if (ppc) {
    <gea-shop-product-structured-data [product]="ppc.product"></gea-shop-product-structured-data>
    <ng-template #contentColumnInner>
      @if (ppc.product) {
        <div class="content-column-inner">
          <div class="content-column-inner-inner">
            <h1 id="jetzt-kaufen" class="mb-2">{{ ppc.product.title }}</h1>
            <div class="my-3">
              <gea-shop-product-single-price
                [selectedAttributes]="currentSelections()"
                [product]="ppc.product"
                [distinctProduct]="distinctProductSignal()"
                [forcePrice]="forcePrice()"
                />
              <div class="d-flex mb-3 align-content-bottom">
                @if (ppc.product.productId != ID_SCHUHSPENDE) {
                  <div class="price-add flex-grow-1">
                    @if (productHasTax()) {
                      inkl. MwSt.
                    }
                    @if (productHasTax() && productHasDeliveryCosts()) {
                      /
                    }
                    @if (productHasDeliveryCosts()) {
                      <span>zzgl.
                        <span class="text-decoration-underline" role="button" [ngbTooltip]="'Die Versandkosten für Schuhe betragen pauschal 8 € nach Österreich, sowie 16 € in andere EU-Staaten. Bei Möbel variiert der Versand je nach Größe und Gewicht zwischen 8 € und 90 €.'">
                          Versand
                        </span>
                      </span>
                    }
                  </div>
                }
                @if (getShareData()) {
                  <gea-shop-share-button [shareData]="getShareData()"></gea-shop-share-button>
                }
              </div>
              <gea-shop-markdown [markdown]="ppc.product.shortDescription" class="d-none d-md-block mb-5" />
            </div>
            @switch (ppc.product.typeId) {
              @case (2) {
                <!-- configurable product -->
                <gea-shop-combiner
                  [product]="asConfigurableProduct(ppc.product)"
                  (distinctProductSelected)="onDistinctProductChange($event)"
                  (priceChanged)="updatePrice($event)"
                  (pictureChanged)="updatePicture($event)"
                  [resetSelectionSubject]="resetSelectionSubject"
                  [distinctRefreshSubject]="distinctRefreshSubject"
                ></gea-shop-combiner>
              }
              @case (3) {
                <!-- matrix product -->
                <gea-shop-configurator
                  [loadedProduct]="asMatrixProduct(ppc.product)"
                  [resetSelectionSubject]="resetSelectionSubject"
                  [distinctRefreshSubject]="distinctRefreshSubject"
                  [triggerValidationSubject]="triggerValidationSubject"
                  [preselection]="configuratorPreselection"
                  (activeVariantChange)="onActiveVariantChange($event)"
                  (distinctProductSelected)="onDistinctProductChange($event)"
                  (currentSelectionChange)="onSelectionChange($event)"
                  #configurator
                ></gea-shop-configurator>
              }
              @case (1) {
                <!-- simple product -->
                <gea-shop-simple-configurator
                  [loadedProduct]="asSimpleProduct(ppc.product)"
                  [resetSelectionSubject]="resetSelectionSubject"
                  [distinctRefreshSubject]="distinctRefreshSubject"
                  [preselection]="configuratorPreselection"
                  (distinctProductSelected)="onDistinctProductChange($event)"
                  (priceChanged)="updatePrice($event)"
                  (currentSelectionChange)="onSelectionChange($event)"
                  (activeVariantChange)="onActiveVariantChange($event)"
                  #simpleconfigurator
                ></gea-shop-simple-configurator>
              }
            }
            <gea-shop-add-to-cart
              [distinctProduct]="distinctProductSignal()"
              [product]="ppc.product"
              (triggerValidation)="triggerValidation()"
              (addToCart)="onAddToCart($event)"
            ></gea-shop-add-to-cart>
            @if (ppc.product.description || ppc.product.shortDescription) {
              <div class="row">
                <div class="col col-12 product-detail mt-3">
                  @if (ppc.product.shortDescription) {
                    <gea-shop-markdown class="d-block d-md-none" [markdown]="ppc.product.shortDescription" />
                    <br/>
                  }
                  @if (ppc.product.description) {
                    <h4 aria-level="2">Produktdetails</h4>
                    <gea-shop-markdown [markdown]="ppc.product.description" />
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </ng-template>

    <!-- CMS Element 1 -->
    @if (ppc.cmsPage && ppc.cmsPage.content['before']) {
      <div class="row">
        <gea-shop-wagtail-elements [elements]="ppc.cmsPage.content['before']"></gea-shop-wagtail-elements>
      </div>
    }
    <div class="row product-container" [class.cms-product]="cmsPage" #productContainer>
      <div class="col-12 col-lg-7 images-column" #imagesColumn>
        <div class="images-column-scroller">
          @for (image of pictures(); track image?.slug ?? $index) {
            @if (image && image.slug) {
              <img
                [ngSrc]="image.slug"
                [attr.alt]="image.alt"
                [attr.title]="image.title"
                class="img-fluid"
                ngSrcset="200w, 300w, 400w, 750w"
                priority
                fill
                />
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" width="636" height="636" viewBox="0 0 180.119 139.794" class="img-fluid" role="img" aria-label="Kein Produktbild verfügbar">
                <g transform="translate(-13.59 -66.639)" paint-order="fill markers stroke">
                  <path fill="#d0d0d0" d="M13.591 66.639H193.71v139.794H13.591z"/>
                  <path d="m118.507 133.514-34.249 34.249-15.968-15.968-41.938 41.937H178.726z" opacity=".675" fill="#fff"/>
                  <circle cx="58.217" cy="108.555" r="11.773" opacity=".675" fill="#fff"/>
                  <path fill="none" d="M26.111 77.634h152.614v116.099H26.111z"/>
                </g>
              </svg>
            }
          }
        </div>
        <div class="circle-nav visible-xs visible-sm">
          @for (image of pictures(); track image?.slug ?? $index; let index = $index) {
            <svg (click)="this.navigateToImage(index)" (keydown.enter)="this.navigateToImage(index)" (keydown.space)="this.navigateToImage(index)" role="button" tabindex="0" [attr.aria-label]="'Zu Bild ' + (index + 1) + ' springen'" [attr.aria-pressed]="activeImageIndex() == index" [class.active]="activeImageIndex() == index" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="14" />
            </svg>
          }
        </div>
      </div>

      <div class="col-12 col-lg-5 content-column">
        <ng-container [ngTemplateOutlet]="contentColumnInner"></ng-container>
      </div>
    </div>

    <!-- CMS Element 2 -->
    @if (ppc.cmsPage && ppc.cmsPage.content['after']) {
      <gea-shop-wagtail-elements [elements]="ppc.cmsPage.content['after']"></gea-shop-wagtail-elements>
    }
    @let cc = carouselContent();
    @if (cc) {
      <div class="row">
        <h3 class="txt-darkgrey text-center my-5">Das könnte dir auch gefallen</h3>
        <gea-shop-product-slider class="mb-9" [contents]="cc"></gea-shop-product-slider>
      </div>
    }
  }
}
